/* tslint:disable */
/* eslint-disable */
/**
 * crm-screener-insurances
 * crm-screener-insurances
 *
 * The version of the OpenAPI document: 1.0.0
 * 
 *
 * NOTE: This class is auto generated by OpenAPI Generator (https://openapi-generator.tech).
 * https://openapi-generator.tech
 * Do not edit the class manually.
 */

import { exists, mapValues } from '../runtime';
import type { PalAuthSubmission } from './PalAuthSubmission';
import {
    PalAuthSubmissionFromJSON,
    PalAuthSubmissionFromJSONTyped,
    PalAuthSubmissionToJSON,
} from './PalAuthSubmission';

/**
 * 
 * @export
 * @interface SubmitPalAuthSubmission201Response
 */
export interface SubmitPalAuthSubmission201Response {
    /**
     * 
     * @type {PalAuthSubmission}
     * @memberof SubmitPalAuthSubmission201Response
     */
    data?: PalAuthSubmission;
}

/**
 * Check if a given object implements the SubmitPalAuthSubmission201Response interface.
 */
export function instanceOfSubmitPalAuthSubmission201Response(value: object): boolean {
    let isInstance = true;

    return isInstance;
}

export function SubmitPalAuthSubmission201ResponseFromJSON(json: any): SubmitPalAuthSubmission201Response {
    return SubmitPalAuthSubmission201ResponseFromJSONTyped(json, false);
}

export function SubmitPalAuthSubmission201ResponseFromJSONTyped(json: any, ignoreDiscriminator: boolean): SubmitPalAuthSubmission201Response {
    if ((json === undefined) || (json === null)) {
        return json;
    }
    return {
        
        'data': !exists(json, 'data') ? undefined : PalAuthSubmissionFromJSON(json['data']),
    };
}

export function SubmitPalAuthSubmission201ResponseToJSON(value?: SubmitPalAuthSubmission201Response | null): any {
    if (value === undefined) {
        return undefined;
    }
    if (value === null) {
        return null;
    }
    return {
        
        'data': PalAuthSubmissionToJSON(value.data),
    };
}

